module.exports = __webpack_public_path__ + "assets/img/vr.121c7149.png";